import { ReactElement } from 'react';

import { Portal } from '@dreryk/react-components';

const DRAFT_PRESCRIPTIONS_STATUS_PORTAL_CONTAINER_ID = 'DRAFT_PRESCRIPTIONS_STATUS_PORTAL';

export const DraftPrescriptionsStatusPanel = (): JSX.Element => (
   <Portal.Container id={DRAFT_PRESCRIPTIONS_STATUS_PORTAL_CONTAINER_ID} testId={'draftPrescriptionsStatus'} />
);

type DraftPRescriptionsStatusPanelPortalProps = {
   readonly children: ReactElement;
};

export const DraftPrescriptionsStatusPanelPortal = (props: DraftPRescriptionsStatusPanelPortalProps): JSX.Element => (
   <Portal containerId={DRAFT_PRESCRIPTIONS_STATUS_PORTAL_CONTAINER_ID}>{props.children}</Portal>
);
